import { NatureGarantie } from "./nature-garantie";

export class NatureGarantieDocument {
  id: number | undefined;
  code: string;
  libelle: string;
  obligatoire: boolean;
  natureGarantie: NatureGarantie;
  typeDocumentGarantieId: number;
  selected: boolean;
}
